import Component from '../abstracts/Component';

export default class SelectComponent extends Component {
  get COMPONENTNAME() {
    return 'SelectComponent';
  }

  get SELECTORS() {
    return {
      select: 'select',
      label: '[data-label]',
      error: '[data-error]'
    }
  }

  get CSS() {
    return {
      edited: '--edited',
      error: '--error'
    }
  }

  constructor(elem) {
    super(elem);
    this.setError = this.setError.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  readDOM() {
    return {
      input: this.$component.querySelector(this.SELECTORS.select),
      label: this.$component.querySelector(this.SELECTORS.label),
      error: this.$component.querySelector(this.SELECTORS.error)
    }
  }

  bindEvents() {
    this.dom = this.readDOM();
    this.dom.input.addEventListener('change', () => {
      this.$component.classList.toggle(this.CSS.edited, this.dom.input.value.length);
    });
    this.dom.input.addEventListener('focus', () => {
      this.$component.classList.add(this.CSS.edited);
    });
    this.dom.input.addEventListener('blur', () => {
      this.$component.classList.toggle(this.CSS.edited, this.dom.input.value.length);
    });
    document.addEventListener('changeLabel', (e) => {
      if(this.$component.dataset.id == e.detail.id) {
        e.detail.required ? this.setLabel(e.detail.label+"*") : this.setLabel(e.detail.label);
      }
    });
  }

  render() {
    this.dom = this.readDOM();
    if (this.dom.input.value.length) {
      this.$component.classList.add(this.CSS.edited);
    }
    this.bindEvents();

  }

  // EXTERNAL API
  setError(msg) {
    this.dom = this.readDOM();
    if (msg !== undefined) {
      this.dom.error.innerText = msg;
    }
    this.$component.classList.add(this.CSS.error);
  }

  resetState() {
    this.dom = this.readDOM();
    this.dom.error.innerText = '';
    this.$component.classList.remove(this.CSS.error);
  }

  get value() {
    this.dom = this.readDOM();
    return this.dom.input.value;
  }

  setLabel(label) {
    this.dom = this.readDOM();
    label = this.dom.input.required ? label+="*" : label;
    this.dom.label.innerHTML = label;
  }
}
